import { DataBean } from "../DataBean";

export class PerformanceEvaluationPeriod extends DataBean {

  public async getPerformanceEvaluationPeriodCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "java.util.List_getPerformanceEvaluationPeriodCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getPerformanceEvaluationPeriod(idperformanceevaluationperiod: number): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "com.orange.people.talent.bean.PerformanceEvaluationPeriod_getPerformanceEvaluationPeriod_Number",
      [idperformanceevaluationperiod]
    );
  }

  public async deletePerformanceEvaluationPeriod(idperformanceevaluationperiod: number): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "boolean_deletePerformanceEvaluationPeriod_Number",
      [idperformanceevaluationperiod]
    );
  }

  public async updatePerformanceEvaluationPeriod(bean: any): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "com.orange.people.talent.bean.PerformanceEvaluationPeriod_updatePerformanceEvaluationPeriod_com.orange.people.talent.bean.PerformanceEvaluationPeriod",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.people.talent.bean.PerformanceEvaluationPeriod",
        },
      ]
    );
  }
}
